document.addEventListener('DOMContentLoaded', function () {
  var carouselWrappers = Array.from(document.querySelectorAll('.carousel-wrapper'));

  // Sort the carousel wrappers based on the data-carousel-id attribute
  carouselWrappers.sort(function (a, b) {
    return parseInt(a.getAttribute('data-carousel-id')) - parseInt(b.getAttribute('data-carousel-id'));
  });

  carouselWrappers.forEach(function (carouselWrapper, index) {
    var carouselId = carouselWrapper.getAttribute('data-carousel-id');
    var carouselPlaceholder = document.querySelector('.carousel-placeholder-' + carouselId);

    // Skip the carousel if there is no placeholder for it
    if (!carouselPlaceholder) {
      return;
    }

    carouselPlaceholder.parentNode.insertBefore(carouselWrapper, carouselPlaceholder.nextSibling);
    carouselPlaceholder.remove(); // Optional: Remove the placeholder span element

    // Initialize the carousel
    var carousel = carouselWrapper.querySelector('.carousel');

    if (carousel) {
      // Define settings for different screen widths
      var mobileSettings = {
        slidesToShow: 1,
        slidesToScroll: 1,
          dots: true,
        arrows: true,
        autoplay: true, // enable autoplay
        autoplaySpeed: 3000, // set autoplay interval to 3 seconds
      };

      var desktopSettings = {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        autoplay: true, // enable autoplay
        autoplaySpeed: 3000, // set autoplay interval to 3 seconds
      };

      // Apply settings based on the screen width
      if (window.matchMedia('(max-width: 767px)').matches) {
        $(carousel).slick(mobileSettings);
      } else {
        $(carousel).slick(desktopSettings);
      }

      // Update settings when the window is resized
      window.addEventListener('resize', function () {
        if (window.matchMedia('(max-width: 767px)').matches) {
          if ($(carousel).hasClass('slick-initialized')) {
            $(carousel).slick('unslick');
          }
          $(carousel).slick(mobileSettings);
        } else {
          if ($(carousel).hasClass('slick-initialized')) {
            $(carousel).slick('unslick');
          }
          $(carousel).slick(desktopSettings);
        }
      });
    }
  });
});
